import api from '../utils/baseUrl';
import axios from 'axios';

class StripeService {
    async onboardAccount() {
        try {
            const response = await api.post('/api/stripe/onboardAccount');
            return response.data.link ?? {};
        } catch (error) {
            console.error('Error onboarding account:', error);
            if (axios.isAxiosError(error) && error.response) {
                return error.response;
            }
        }
    }
}

export default new StripeService();